import { ChartContainer } from '../../../../ui/chart';
import { PieChart, Pie, Cell } from 'recharts';
import type { VideoResult, Sentiment } from '../../types';
import { safetyChartConfig } from '../../constants';
import { AgentLabel } from '../../shared';

interface DonutDatum {
  name: string;
  value: number;
  color: string;
}

interface SentimentAgentPanelProps {
  video: VideoResult;
  sent: Sentiment;
  donutData: DonutDatum[];
  donutShown: DonutDatum[];
}

export function SentimentAgentPanel({ video, sent, donutData, donutShown }: SentimentAgentPanelProps) {
  return (
    <div
      style={{
        background: '#fff',
        border: '1px solid #E5E5E5',
        borderRadius: 8,
        padding: 18,
        display: 'flex',
        flexDirection: 'column',
        gap: 12,
      }}
    >
      <AgentLabel>SENTIMENT MIX</AgentLabel>
      <div style={{ display: 'flex', gap: 20, alignItems: 'center' }}>
        <div style={{ position: 'relative', width: 148, height: 148, flexShrink: 0 }}>
          <ChartContainer config={safetyChartConfig} className="size-[148px]">
            <PieChart>
              <Pie
                isAnimationActive={false}
                data={donutShown.length ? donutShown : [{ name: 'None', value: 1, color: '#F5F5F5' }]}
                cx={68}
                cy={69}
                innerRadius={52}
                outerRadius={74}
                dataKey="value"
                stroke="none"
              >
                {(donutShown.length ? donutShown : [{ color: '#F5F5F5' }]).map((d, i) => (
                  <Cell key={i} fill={(d as { color: string }).color} />
                ))}
              </Pie>
            </PieChart>
          </ChartContainer>
          <div
            style={{
              position: 'absolute',
              inset: 0,
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <span style={{ fontSize: 18, fontWeight: 600, color: '#171717', lineHeight: 1 }}>
              {video.comments_analyzed.toLocaleString()}
            </span>
            <span style={{ fontSize: 12, fontWeight: 500, color: '#737373', marginTop: 2 }}>Comments</span>
          </div>
        </div>
        <div style={{ flex: 1, minWidth: 0, display: 'flex', flexDirection: 'column', gap: 16 }}>
          {donutData.map((d) => (
            <div key={d.name} style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
              <span style={{ width: 11, height: 11, borderRadius: 3, background: d.color, flexShrink: 0 }} />
              <span style={{ width: 68, fontSize: 12, fontWeight: 500, color: '#171717' }}>{d.name}</span>
              <div style={{ flex: 1, height: 6, borderRadius: 999, background: '#F5F5F5', overflow: 'hidden' }}>
                <div style={{ height: '100%', width: `${Math.min(d.value, 100)}%`, background: d.color, borderRadius: 999 }} />
              </div>
              <span style={{ width: 40, textAlign: 'right', fontSize: 12, fontWeight: 500, color: '#171717' }}>
                {d.value.toFixed(1)}%
              </span>
            </div>
          ))}
        </div>
      </div>
      {sent.summary && (
        <div>
          <div style={{ fontSize: 14, fontWeight: 500, color: '#171717', marginBottom: 6 }}>
            What the comments say
          </div>
          <p style={{ margin: 0, fontSize: 14, fontWeight: 400, color: '#404040', lineHeight: 1.6 }}>
            {sent.summary}
          </p>
        </div>
      )}
    </div>
  );
}
